import { PostListImage } from "./PostListImage";

export { PostListImage };
